import React, { useState, useEffect } from "react";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import {
  Layout,
  Space,
  Card,
  Row,
  Col,
  Button,
  Form,
  Select,
  Table,
  Tag,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStates } from "../features/statecity/statecitySlice";
import {
  getWeeklyAttendance,
  resetState as resetAttendanceState,
} from "../features/attendance/attendanceSlice";
import { getUsers, getaUser } from "../features/cutomers/customerSlice";
import { getSchoolVisitData } from "../features/schools/schoolSlice";
import { toast } from "react-toastify";
import CustomerPopupModal from "../components/CustomerPopupModal";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { ClockCircleOutlined } from "@ant-design/icons";
import AttendanceImagePopupModal from "../components/AttendanceImagePopupModal";

const { Content } = Layout;

const columns = [
  {
    title: "S. No",
    dataIndex: "sno",
    key: "sno",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Punch In / Out",
    dataIndex: "punchIn",
    key: "punchIn",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Production Hours",
    dataIndex: "production_hour",
    key: "production_hour",
  },
  {
    title: "Device Info",
    dataIndex: "device_info",
    key: "device_info",
  },
];

const Attendance_main = () => {
  const [vcPresent, setVcPresent] = useState(0);
  const [vcAbsent, setVcAbsent] = useState(0);
  const [vtPresent, setVtPresent] = useState(0);
  const [vtAbsent, setVtAbsent] = useState(0);
  const [vcData, setvcData] = useState([]);
  const [vtData, setvtData] = useState([]);
  const [selectedVC, setselectedVC] = useState("");
  const [selectedVT, setselectedVT] = useState("");
  const [selectedState, setselectedState] = useState("");
  const [selectedStatevc, setselectedStatevc] = useState("");
  const [selectedStatevt, setselectedStatevt] = useState("");
  const [attendanceData, setAttendanceData] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [opens, setOpens] = useState(false);
  const [openpopup, setOpenpopup] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [popupImages, setPopupImages] = useState([]);
  const [popupType, setPopupType] = useState("");

  const [form] = Form.useForm();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetAttendanceState());
    dispatch(getUsers());
    dispatch(getStates());
  }, [dispatch]);

  const userinfo = localStorage.getItem("user");
  const userData = JSON.parse(userinfo);
  const token = userData.token;

  if (!token) {
    throw new Error("Token not found in local storage");
  }

  const statelistState = useSelector((state) => state.statecity.statelist);
  const vclistState = useSelector((state) => state.customer.customers);
  const newAttendance = useSelector((state) => state.attendance.attendances);
  const newUser = useSelector((state) => state.customer.customerinfo);

  const openModal = (customerId) => {
    setOpens(true);
    setCustomerId(customerId);
  };

  const closeModal = () => {
    setOpens(false);
  };

  const openPopupModal = async (customerId, type = "school") => {
    setCustomerId(customerId);
    try {
      let images = [];
      if (type === "attendance" || type === "compliance") {
        const response = await axios.get(
          `${base_url}attendancereport/getallMonthlyAttendancndCompliance/${customerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (type === "attendance") {
          images = response.data.attendance || [];
        } else if (type === "compliance") {
          images = response.data.compliance || [];
        }
        console.log(`${type} images:`, images);
      } else if (type === "school") {
        const result = await dispatch(getSchoolVisitData(customerId)).unwrap();
        console.log("School visit API result:", result);
        images =
          result.visits && result.visits.length > 0
            ? result.visits.flatMap((visit) => visit.photos || [])
            : [];
        console.log("Processed school visit photos:", images);
      }
      setPopupImages(images);
      setPopupType(type);
      setOpenpopup(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      setPopupImages([]);
      setPopupType(type);
      setOpenpopup(true);
    }
  };

  const closePopupModal = () => {
    setOpenpopup(false);
    setPopupImages([]);
    setPopupType("");
  };

  const handleStateVTChange = async (value) => {
    setselectedStatevt(value);
    try {
      const response = await axios.get(
        `${base_url}attendancereport/statewise/${value}/vt`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setVtPresent(response.data.data.presentCount);
        setVtAbsent(response.data.data.absentCount);
      }
    } catch (error) {
      console.error("Error fetching VT attendance:", error);
      setVtPresent(0);
      setVtAbsent(0);
    }
  };

  const handleStateVCChange = async (value) => {
    setselectedStatevc(value);
    try {
      const response = await axios.get(
        `${base_url}attendancereport/statewise/${value}/vc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setVcPresent(response.data.data.presentCount);
        setVcAbsent(response.data.data.absentCount);
      }
    } catch (error) {
      console.error("Error fetching VC attendance:", error);
      setVcPresent(0);
      setVcAbsent(0);
    }
  };

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setselectedState(value);
  };

  const handleVcChange = (value) => {
    const vtfilterData = vclistState.filter(
      (customer) => customer.vcuser_id === value
    );
    setvtData(vtfilterData);
    setselectedVT(value);
  };

  const handleSubmit = (values) => {
    let user_id;
    const vc_userid = values.vc_name;
    const vt_userid = values.vt_name;

    if (vt_userid === undefined) {
      user_id = vc_userid;
    } else {
      user_id = vt_userid;
    }

    toast.success("Filters applied successfully!");
    if (values) {
      setCustomerId(user_id);
      dispatch(getaUser(user_id));
      dispatch(getWeeklyAttendance(user_id));
    }
  };

  const handleClear = () => {
    form.resetFields();
    setselectedState("");
    setselectedVC("");
    setselectedStatevt("");
    setAttendanceData([]);
    setvcData([]);
    setvtData([]);
    setUserInfo(null);
    setVcPresent(0);
    setVcAbsent(0);
    setVtPresent(0);
    setVtAbsent(0);
  };

  const processData = (data) => {
    if (!data || !data.data || !data.data.totalAttendanceByUserDay) {
      return [];
    }

    const globalData = {
      punchIn: null,
      punchOut: null,
      userInfo: {},
    };

    const processedData = data.data.totalAttendanceByUserDay.flatMap(
      (attendanceDay, index) =>
        attendanceDay.attendanceRecords.map((record, recordIndex) => {
          globalData.userInfo = {
            userId: record.user_id._id,
            userName: record.user_id.name,
            punchIn: new Date(attendanceDay.todaypunchIn).toLocaleString(),
            punchOut: new Date(attendanceDay.todaypunchOut).toLocaleString(),
            deviceInfo: record.device_info,
            IP: record.IP,
            totalPresentDays: data.data.totalPresentDays,
            totalDiaryUploads: data.data.totalDiaryUploads,
            totalGuestLectures: data.data.totalGuestLectures,
            totalIndustrialVisits: data.data.totalIndustrialVisits,
          };

          return {
            key: `${index}-${recordIndex}`,
            sno: recordIndex + 1,
            date: record.date,
            punchIn: record.punchInTime
              ? new Date(record.punchInTime).toLocaleString()
              : new Date(record.punchOutTime).toLocaleString(),
            type:
              record.type === "PunchIn" ? (
                <Tag color="green">Punch In</Tag>
              ) : (
                <Tag color="red">Punch Out</Tag>
              ),
            production_hour: (
              <Space>
                <ClockCircleOutlined />
                {`${attendanceDay.totalWorkingHours.hours}h ${attendanceDay.totalWorkingHours.minutes}m ${attendanceDay.totalWorkingHours.seconds}s`}
              </Space>
            ),
            device_info: record.device_info || "",
            action: "",
          };
        })
    );

    setUserInfo(globalData.userInfo);
    return processedData;
  };

  useEffect(() => {
    if (newAttendance) {
      setAttendanceData(processData(newAttendance));
    }
  }, [newAttendance]);

  return (
    <Layout>
      <Layout style={{ padding: "0 24px 24px" }}>
        <h3 className="mb-4 title">Attendance</h3>
        <Content
          className="site-layout-background"
          style={{
            padding: 14,
            margin: 0,
            minHeight: 280,
          }}
        >
          <Row
            gutter={16}
            style={{
              marginTop: 12,
              backgroundColor: "transparent",
              padding: "0",
            }}
          >
            <Col span={12}>
              <Card title="VC's Attendance" bordered={false}>
                <Form>
                  <Form.Item
                    name="state_name_vc"
                    rules={[
                      { required: true, message: "Please Select State!" },
                    ]}
                  >
                    <Select
                      placeholder="Select State"
                      onChange={handleStateVCChange}
                      style={{ width: 150, marginRight: 5 }}
                    >
                      <Select.Option key="default" value="">
                        Select State
                      </Select.Option>
                      {statelistState.map((i, j) => (
                        <Select.Option key={j} value={i.code}>
                          {i.state_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form>
                <Button
                  type="primary"
                  className="gradient-button"
                  style={{ marginLeft: 10 }}
                >
                  Present: {vcPresent}
                </Button>
                <Button
                  type="primary"
                  className="gradient-button"
                  style={{ marginLeft: 10 }}
                >
                  Absent: {vcAbsent}
                </Button>
              </Card>
            </Col>

            <Col span={12}>
              <Card title="VT's Attendance" bordered={false}>
                <Form>
                  <Form.Item
                    name="state_name_vt"
                    rules={[
                      { required: true, message: "Please Select State!" },
                    ]}
                  >
                    <Select
                      placeholder="Select State"
                      onChange={handleStateVTChange}
                      style={{ width: 150, marginRight: 5 }}
                    >
                      <Select.Option key="default" value="">
                        Select State
                      </Select.Option>
                      {statelistState.map((i, j) => (
                        <Select.Option key={j} value={i.code}>
                          {i.state_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form>
                <Button
                  type="primary"
                  className="gradient-button"
                  style={{ marginLeft: 10 }}
                >
                  Present: {vtPresent}
                </Button>
                <Button
                  type="primary"
                  className="gradient-button"
                  style={{ marginLeft: 10 }}
                >
                  Absent: {vtAbsent}
                </Button>
              </Card>
            </Col>
          </Row>

          <Row
            gutter={16}
            style={{
              marginTop: 12,
              backgroundColor: "transparent",
              padding: "0",
            }}
          >
            <Col span={24}>
              <Card title="Filter Attendance" bordered={false}>
                <Form form={form} layout="inline" onFinish={handleSubmit}>
                  <Form.Item
                    name="state_name"
                    rules={[
                      { required: true, message: "Please Select State!" },
                    ]}
                  >
                    <Select
                      placeholder="Select State"
                      onChange={handleStateChange}
                      style={{ width: 150, marginRight: 5 }}
                    >
                      <Select.Option key="default" value="">
                        Select State
                      </Select.Option>
                      {statelistState.map((i, j) => (
                        <Select.Option key={j} value={i.code}>
                          {i.state_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="vc_name"
                    rules={[{ required: true, message: "Please Select VC!" }]}
                  >
                    <Select
                      placeholder="Select VC"
                      onChange={handleVcChange}
                      style={{ width: 150, marginRight: 5 }}
                    >
                      <Select.Option key="default" value="">
                        Select VC
                      </Select.Option>
                      {vcData
                        .filter((item) => item.role === "vc")
                        .map((item) => (
                          <Select.Option key={item._id} value={item._id}>
                            {item.name}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name="vt_name">
                    <Select
                      placeholder="Select VT"
                      style={{ width: 150, marginRight: 5 }}
                    >
                      <Select.Option key="default" value="">
                        Select VT
                      </Select.Option>
                      {vtData
                        .filter((item) => item.role === "vt")
                        .map((item) => (
                          <Select.Option key={item._id} value={item._id}>
                            {item.name}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Search
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button type="default" onClick={handleClear}>
                      Clear
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          </Row>

          <CustomerPopupModal
            open={opens}
            hideModal={closeModal}
            user_info={vclistState}
            user_id={customerId}
          />

          {userInfo ? (
            <Row gutter={16} style={{ marginTop: 24 }}>
              <Col span={8}>
                <Card
                  title="User Profile"
                  bordered={true}
                  style={{ textAlign: "center" }}
                >
                  <p>
                    <strong> Name:</strong> {newUser.name}
                  </p>
                  <p>
                    <strong>Email ID:</strong> {newUser.email}
                  </p>
                  <p>
                    <strong>Device Info:</strong> {userInfo.deviceInfo}
                  </p>
                  <p>
                    <strong>Profile Image:</strong>
                    <img
                      src={
                        newUser && newUser.images && newUser.images[0]
                          ? newUser.images[0].url
                          : "https://i.pinimg.com/originals/0d/64/98/0d64989794b1a4c9d89bff571d3d5842.jpg"
                      }
                      alt="User Profile"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                      }}
                    />
                  </p>
                  <Button
                    type="primary"
                    style={{ marginTop: 10 }}
                    onClick={() => openModal(customerId)}
                  >
                    View Profile <FaEye />
                  </Button>
                </Card>
              </Col>
              <Col span={8}>
                <Card
                  title="Today's Activity"
                  bordered={false}
                  style={{ textAlign: "center" }}
                >
                  <p>
                    <Button type="default" style={{ marginBottom: 10 }}>
                      Punch In: {userInfo.punchIn}
                    </Button>
                  </p>
                  <p>
                    <Button type="default" style={{ marginBottom: 10 }}>
                      Punch Out: {userInfo.punchOut}
                    </Button>
                  </p>

                  <Link
                    type="primary"
                    to={`/admin/attendance-view/${customerId}`}
                  >
                    <button type="primary" className="view-button">
                      View All
                    </button>
                  </Link>
                </Card>
              </Col>

              <Col span={8}>
                <Card
                  title="Attendance Details"
                  bordered={true}
                  style={{ textAlign: "center" }}
                >
                  <p>
                    <Button type="default" style={{ marginBottom: 4 }}>
                      Total No of Days: 26
                    </Button>
                  </p>
                  <p>
                    <Button type="default" style={{ marginBottom: 4 }}>
                      Total Present: {userInfo.totalPresentDays}
                    </Button>
                  </p>
                  <p>
                    <Button type="default" style={{ marginBottom: 4 }}>
                      No. of Dairy Uploads: {userInfo.totalDiaryUploads}
                    </Button>
                  </p>
                  <p>
                    <Button type="default" style={{ marginBottom: 4 }}>
                      No. of Guest Lectures: {userInfo.totalGuestLectures}
                    </Button>
                  </p>
                  <p>
                    <Button type="default" style={{ marginBottom: 4 }}>
                      No. of Industrial Visits: {userInfo.totalIndustrialVisits}
                    </Button>
                  </p>
                  <Button
                    type="primary"
                    style={{ marginTop: 4 }}
                    onClick={() => openPopupModal(customerId, "attendance")}
                  >
                    View Monthly Attendance Upload <FaEye />
                  </Button>

                  <Button
                    type="primary"
                    style={{ marginTop: 4 }}
                    onClick={() => openPopupModal(customerId, "compliance")}
                  >
                    View Monthly Compliance <FaEye />
                  </Button>
                  <Button
                    type="primary"
                    style={{ marginTop: 4 }}
                    onClick={() => openPopupModal(customerId, "school")}
                  >
                    View School Visit <FaEye />
                  </Button>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row gutter={16} style={{ marginTop: 24 }}>
              <Col span={24}>
                <p>Please apply filters to view attendance details.</p>
              </Col>
            </Row>
          )}

          <Row gutter={16} style={{ marginTop: 24 }}>
            <Col span={24}>
              <Card title="Weekly Attendance" bordered={true}>
                <Table
                  columns={columns}
                  className="custom-table"
                  dataSource={attendanceData}
                  pagination={false}
                />
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>

      <AttendanceImagePopupModal
        open={openpopup}
        images={popupImages}
        onClose={closePopupModal}
        type={popupType}
      />
    </Layout>
  );
};

export default Attendance_main;
